import { Card, CardActions, CardMedia, Grid, IconButton, Paper, Typography } from "@mui/material";
import styled from "styled-components";
import { BsPersonGear, BsArrowUpCircle } from "react-icons/bs";
import { BiShareAlt } from "react-icons/bi";
import { useEffect, useState } from "react";
import NftPreviewModal from "../modal/NftPreviewModal";
import NftShareModal from "../modal/NftShareModal";
import { getUserData, isUserSignedIn, authenticatedUserAddress } from "../../services/auth";
import { clientNetwork } from "../../lib/constants";
import NftTransferModal from "../modal/NftTransferModal";
import NftLoadoutModal from "../modal/NftLoadoutModal";
import { getNames } from "../../services/stacks";
import BnsWarningModal from "../modal/BnsWarningModal"


const StyledPaper = styled(Paper)(() => ({
    backgroundColor: 'transparent',
    marginBottom: '0.5rem',
    borderTopLeftRadius: '15px',
    borderTopRightRadius: '15px'
}))

const StyledCardActions = styled(CardActions)(() => ({
    justifyContent: 'center',
    backgroundImage: 'linear-gradient(to right, #F7931A , #6444fe)',
    borderBottomLeftRadius: '15px',
    borderBottomRightRadius: '15px'
}))

// StyledIcons
// const StyledHiOutlineViewfinderCircle = styled(HiOutlineViewfinderCircle)(() => ({
//     color: 'white'
// }))
const StyledBsPersonGear = styled(BsPersonGear)(() => ({
    color: 'white'
}))
const StyledBiShareAlt = styled(BiShareAlt)(() => ({
    color: 'white'
}))
const StyledBsArrowUpCircle = styled(BsArrowUpCircle)(() => ({
    color: 'white'
}))

const NftCards = ({ id, imageUrl, contractId, authorPrincipal, userSettings }) => {
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [nftTransferModalOpen, setNftTransferModalOpen] = useState(false);
    const [shareModalOpen, setShareModalOpen] = useState(false);
    // const [nftAttributes, setNftAttributes] = useState([]);
    const [showLoudOutModal, setShowLoudOutModal] = useState(false);
    const [showBnsWaring, setShowBnsWaring] = useState(false);

    // const { doContractCall } = useConnect();
    //let authUser = getUserData().profile.stxAddress.testnet;
    let authUser = authenticatedUserAddress({ network: clientNetwork });
    console.log("p3 automagic networking: " + authUser);
    // async function previewBtn() {
    //     const txOption = {
    //         contractAddress: contractId.asset_identifier.split('.')[0],
    //         contractName: contractId.asset_identifier.split('.')[1].split('::')[0],
    //         functionName: 'get-token-uri',
    //         functionArgs: [uintCV(id)],
    //         network: new StacksMainnet(),
    //         senderAddress: bnsContractAddress,
    //     }
    //     const { value: { value: { data } } } = await callReadOnlyFunction(txOption);
    //     let jsonUrl;
    //     for (const key in supportedOrigins) {
    //         if (data.includes(key)) {
    //             jsonUrl = data.replace(key, supportedOrigins[key]);
    //         }
    //         if (data.includes('{id}')) {
    //             jsonUrl = String(jsonUrl).replace('{id}', id);
    //         }
    //     }
    //     const res = await (await axios.get(jsonUrl)).data;
    //     if (res.attributes) {
    //         for (let i = 0; i < res.attributes.length; i++) {
    //             setNftAttributes(nftAttributes => [...nftAttributes, { id: res.attributes[i].type, value: res.attributes[i].value }]);
    //         }
    //     };
    //     setViewModalOpen(true);
    // }

    async function pfpNftBtn() {
        const { success, names } = await getNames(authUser)
        if (success && names.length > 0) {
            setShowLoudOutModal(true)
        } else {
            setShowBnsWaring(true)
        }
    }

    async function transferBtn() {
        setNftTransferModalOpen(!nftTransferModalOpen);
    }

    function shareBtn() {
        setShareModalOpen(!shareModalOpen);
    }

    useEffect(() => {
    }, [viewModalOpen, shareModalOpen])

    return (
        <>
            <Grid item>
                <StyledPaper>
                    <Card
                        sx={{ height: '100%', width: '100%', backgroundColor: 'rgba(255, 255, 255, 0)', borderTopLeftRadius: '15px', borderTopRightRadius: '15px' }}
                    >
                        <CardMedia
                            component="img"
                            alt="NFT"
                            sx={{ height: '13rem', objectFit: 'cover' }}
                            image={imageUrl}
                        />
                        <Typography variant="h6" className="nft-card-text" sx={{ color: '#f7931a' }}>
                            #{id}
                        </Typography>
                        <StyledCardActions>
                            {/* <IconButton aria-label="View" className="nft-card-buttons" onClick={previewBtn}>
                                <StyledHiOutlineViewfinderCircle />
                            </IconButton> */}
                            {authUser === authorPrincipal && authorPrincipal !== undefined &&
                                <IconButton aria-label="Transfer" className="nft-card-buttons" onClick={transferBtn}>
                                    <StyledBsArrowUpCircle />
                                </IconButton>
                            }

                            <IconButton aria-label="Share" className="nft-card-buttons" onClick={shareBtn}>
                                <StyledBiShareAlt />
                            </IconButton>

                            {authUser === authorPrincipal && authorPrincipal !== undefined &&
                                <IconButton aria-label="Save as Avatar" className="nft-card-buttons" onClick={pfpNftBtn}>
                                    <StyledBsPersonGear />
                                </IconButton>
                            }
                        </StyledCardActions>
                    </Card>
                </StyledPaper>
            </Grid>
            <NftTransferModal show={nftTransferModalOpen} nftId={id} contractId={contractId} setShow={setNftTransferModalOpen} authedUser={authUser} imageUrl={imageUrl} userSettings={userSettings} />
            <NftShareModal show={shareModalOpen} nftId={id} contractId={contractId} close={() => setShareModalOpen(false)} />
            <NftPreviewModal show={viewModalOpen} close={() => setViewModalOpen(false)} id={id} imageUrl={imageUrl}
            // meta={nftAttributes} 
            />
            <NftLoadoutModal show={showLoudOutModal} nftId={id} contractId={contractId} close={() => setShowLoudOutModal(false)} imageUrl={imageUrl} />
            <BnsWarningModal show={showBnsWaring} close={() => setShowBnsWaring(false)} />
        </>

    )
}

export default NftCards;